import Bowser, { BROWSER_MAP } from 'bowser';

export const checkIfSafari = () => {
  const userAgent = window?.navigator?.userAgent;
  const browser = Bowser.getParser(userAgent);
  return browser.getBrowserName() === BROWSER_MAP.safari;
};
